import Cookies from 'js-cookie'

// 存储相关工具函数
export const storageUtils = {
  // 清理所有用户相关的存储数据
  clearUserData() {
    // 清理cookies（保留language）
    const cookiesToRemove = [
      'token',
      'userName', 
      'userToken',
      'userInfo'
    ]
    
    cookiesToRemove.forEach(key => {
      Cookies.remove(key)
    })
    
    // 清理localStorage（保留language）
    const localStorageKeysToRemove = [
      'token',
      'userName',
      'userToken', 
      'userInfo'
    ]
    
    localStorageKeysToRemove.forEach(key => {
      localStorage.removeItem(key)
    })
    
    // 清理sessionStorage
    const sessionStorageKeysToRemove = [
      'token',
      'userName',
      'userToken',
      'userInfo'
    ]
    
    sessionStorageKeysToRemove.forEach(key => {
      sessionStorage.removeItem(key)
    })
  },
  
  // 设置用户数据
  setUserData(userData) {
    const { token, userName } = userData
    
    if (token) {
      Cookies.set('token', token, { expires: 7 })
      Cookies.set('userToken', token, { expires: 7 })
      localStorage.setItem('token', token)
      localStorage.setItem('userToken', token)
    }
    
    if (userName) {
      Cookies.set('userName', userName, { expires: 7 })
      localStorage.setItem('userName', userName)
    }
  },
  
  // 获取用户数据
  getUserData() {
    return {
      token: Cookies.get('token') || localStorage.getItem('token'),
      userName: Cookies.get('userName') || localStorage.getItem('userName'),
      userToken: Cookies.get('userToken') || localStorage.getItem('userToken')
    }
  },
  
  // 语言管理
  setLanguage(language) {
    localStorage.setItem('language', language)
    // 也可以存储到cookies，但通常localStorage就足够了
    Cookies.set('language', language, { expires: 365 }) // 1年过期
  },
  
  getLanguage() {
    return localStorage.getItem('language') || Cookies.get('language') || 'es'
  },

  // 机构相关存储函数
  setOrgData(orgData) {
    // 存储完整的机构数据到 ORGToken cookie（模拟原始HTML的行为）
    Cookies.set('ORGToken', JSON.stringify(orgData), { expires: 7 })
    
    // 同时存储到localStorage作为备份
    localStorage.setItem('ORGToken', JSON.stringify(orgData))
    
    // 提取关键信息单独存储
    if (orgData.secretId) {
      Cookies.set('orgToken', orgData.secretId, { expires: 7 })
      localStorage.setItem('orgToken', orgData.secretId)
    }
    
    if (orgData.orgCode) {
      Cookies.set('orgUserName', orgData.orgCode, { expires: 7 })
      localStorage.setItem('orgUserName', orgData.orgCode)
    }
  },

  getOrgData() {
    try {
      // 优先从cookie获取完整数据
      const orgTokenCookie = Cookies.get('ORGToken')
      if (orgTokenCookie) {
        return JSON.parse(decodeURIComponent(orgTokenCookie))
      }
      
      // 从localStorage获取
      const orgTokenStorage = localStorage.getItem('ORGToken')
      if (orgTokenStorage) {
        return JSON.parse(orgTokenStorage)
      }
      
      // 降级到单独存储的数据
      return {
        secretId: Cookies.get('orgToken') || localStorage.getItem('orgToken'),
        orgCode: Cookies.get('orgUserName') || localStorage.getItem('orgUserName'),
        userToken: Cookies.get('orgUserToken') || localStorage.getItem('orgUserToken')
      }
    } catch (error) {
      console.error('Error parsing org data:', error)
      return {}
    }
  },

  // 获取机构ID（模拟config.js的getOrgId方法）
  getOrgId() {
    const orgData = this.getOrgData()
    return orgData.id || orgData.orgId
  },

  // 获取SecretId（模拟config.js的getSecretId方法）
  getSecretId() {
    const orgData = this.getOrgData()
    return orgData.secretId
  },

  clearOrgData() {
    // 清理机构cookies（保留language）
    const orgCookiesToRemove = [
      'ORGToken',  // 完整的机构数据
      'orgToken',
      'orgUserName', 
      'orgUserToken'
    ]
    
    orgCookiesToRemove.forEach(key => {
      Cookies.remove(key)
    })
    
    // 清理机构localStorage（保留language）
    const orgLocalStorageKeysToRemove = [
      'ORGToken',  // 完整的机构数据
      'orgToken',
      'orgUserName',
      'orgUserToken'
    ]
    
    orgLocalStorageKeysToRemove.forEach(key => {
      localStorage.removeItem(key)
    })
  }
}
